import {
    formatBytes,
    formatCurrency as formatCurrencyOriginal,
    formatDate,
    formatDateTime,
    formatDateToRelative,
    formatISODate,
    formatISODateTime,
    formatISOTime,
    formatNumber,
    formatUsd,
    LUXON_FORMAT_TOKENS,
    numberToMonth,
} from '@shared/utils/core/formatting';
import { formatPhoneNumber } from '@shared/utils/core/phone-format';

export function useFormatter(
    defaultOptions: Parameters<typeof formatCurrencyOriginal>[1] = { maximumFractionDigits: 2 },
) {
    //TODO: Later we'll load formatting configuration from the client settings

    return {
        fDateShortDayJs: 'DD/MM/YYYY',
        fDateShortLxn: 'dd/MM/yyyy',
        fDateTimeDayJs: 'DD/MM/YYYY h:mm A',
        fDateTimeLxn: 'dd/MM/yyyy HH:mm:ss',
        fTimeDayJs: 'h:mm A',
        fTimeLxn: 'HH:mm a',
        lxnDateTimeFormats: LUXON_FORMAT_TOKENS,

        formatCurrency(
            value: Parameters<typeof formatCurrencyOriginal>[0],
            options?: Parameters<typeof formatCurrencyOriginal>[1],
        ) {
            return formatCurrencyOriginal(value, {
                maximumFractionDigits:
                    options?.maximumFractionDigits !== undefined
                        ? options.maximumFractionDigits
                        : defaultOptions.maximumFractionDigits,
            });
        },

        formatPercentage(
            value: number | null | undefined,
            options?: {
                minimumFractionDigits?: number;
                maximumFractionDigits?: number;
                locale?: string;
            },
        ) {
            if (value === null || value === undefined) {
                return '';
            }

            const formatter = new Intl.NumberFormat(options?.locale || 'en-US', {
                style: 'percent',
                minimumFractionDigits: options?.minimumFractionDigits ?? 0,
                maximumFractionDigits: options?.maximumFractionDigits ?? 2,
            });

            return formatter.format(value);
        },

        formatBytes,
        formatDateTime,
        formatISODateTime,
        formatISOTime,
        formatDate,
        formatISODate,
        formatDateToRelative,
        numberToMonth,
        formatNumber,
        formatPhoneNumber,
        formatUsd,
    };
}

export type Formatter = ReturnType<typeof useFormatter>;
